<mat-icon (mouseup)="previous()" class="icon" [hidden]="isDisabled()">arrow_back_ios</mat-icon>
<renderer #renderer></renderer>
<mat-icon (mouseup)="next()" class="icon" [hidden]="isDisabled()">arrow_forward_ios</mat-icon>